<template>
  <v-touch v-on:tap="$emit('eventClicked', event.obj)">
    <div class="day-cal__event" :style="styleObject" :class="{'day-cal__event--is-canceled': event.obj.canceled}">
      <div class="d-cal__event-meta d-cal__event-meta__fixed d-cal__event-meta--warning"
           :class="{'d-cal__event-meta__fixed--canceled': event.obj.canceled}"
           v-if="event.obj.away || event.obj.canceled">
        <span class="icon-notification22" v-if="event.obj.canceled"></span>
        <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="1.5" stroke="currentColor" class="tw-icon tw-icon--warning">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"></path>
        </svg>
        {{ getEventWarningLabel(event.obj) }}
      </div>
      <div class="day-cal__event__content">
        <span>{{event.obj.title }}</span>
        <span>{{event.obj.start | timeStamp}} - {{event.obj.end | timeStamp}}</span>
        <span v-show="event.obj.has_notes" class="notes-icon icon-file-text2"></span>
        <div v-show="event.obj.group"><span class="icon-users"></span> {{event.obj.group}}</div>
        <div v-show="event.obj.teacher"><span class="icon-user"></span> {{event.obj.teacher}}</div>
        <div v-show="event.obj.room"><span class="icon-location"></span> {{event.obj.room}}</div>
      </div>
      <div class="day-cal__event__bg" :style="{backgroundColor: event.obj.color}"></div>
      <div class="day-cal__event__sider" :style="{backgroundColor: event.obj.color}"></div>
    </div>
  </v-touch>
</template>

<script>
  import filters from '../../../../filters/filters' // eslint-disable-line no-unused-vars

  export default {
    props: ['event', 'start', 'i18n'],
    data () {
      return {
        slotHeight: 40
      }
    },
    computed: {
      styleObject () {
        let styleObject = {
          borderColor: this.event.obj.color,
          height: this.event.height + 'px',
          top: (this.event.top - 1) + 'px',
          left: this.event.left + '%',
          width: this.event.width + '%'
        }
        return styleObject
      }
    },
    methods: {
      getEventWarningLabel (eventObj) {
        if (eventObj.canceled) {
          return this.i18n.canceled
        }
        if (eventObj.away) {
          return this.i18n.out_of_school
        }
      }
    }
  }
</script>

<style scoped>
  .day-cal__event {
    color: white;
    display: block;
    font-size: .85em;
    line-height: 1.3;
    font-weight: 400;
    position: absolute;
    z-index: 1;
    top: 20px;
    left: 0%;
    right: 0%;
    border-right: 1px solid transparent !important;
    border-top: 1px solid transparent !important;
  }

  .day-cal__event__content {
    color: white;
    position: absolute;
    width: 100%;
    height: 100%;
    padding: 3px 2px 3px 8px;
    left: 0;
    top: 0;
    font-size: 1rem;
    z-index: 1;
    overflow: hidden;
  }

  .day-cal__event__bg {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    opacity: 0.8;
  }

  .day-cal__event__sider {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 4px;
    z-index: 2;
  }
  .notes-icon {
    position: absolute;
    right: 2px;
    top: 2px;
    z-index: 10;
  }

  .day-cal__event--is-canceled .day-cal__event__content {
    position: relative;
    color: #222;
    background-color: #fff !important;
    background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' preserveAspectRatio='none' viewBox='0 0 100 100'><path d='M100 0 L0 100 ' stroke='red' stroke-width='2'/><path d='M0 0 L100 100 ' stroke='red' stroke-width='2'/></svg>");
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100% 100%, auto;
  }


  .d-cal__event-meta__fixed.d-cal__event-meta__fixed--canceled {
    background-color: #fddddd;
    color: #c20006;
    padding: 2px 4px;
  }
  .d-cal__event-meta__fixed {
    position: absolute;
    z-index: 123123;
    top: 0;
    right: 0;
    font-weight: normal;
    border-radius: 0 0 0 4px;
    font-size: 10px;
    line-height: 0;
    padding: 1px;
    color: #a26206;
    background-color: #fefce8;
    display: flex;
    align-items: center;
    gap: 0.25rem
  }

  .d-cal__event-meta .tw-icon {
    width: 13px;
  }

  .tw-icon--warning {
    margin-bottom: -1px;
  }
</style>



// WEBPACK FOOTER //
// DayCalEvent.vue?f8b071a6